import React, {
  Component,
  PropType,s
} from 'react'
import { Form } from 'semantic-ui-react'
import { connect } from 'react-redux'
import { selectStoreId } from 'store/preferences/selectors'
import CmsApis from 'apis/cmsApis'
/*eslint-disable */

const mapStateToProps = (state) => ({
  storeId: selectStoreId(state),
})

const enhancer = connect(mapStateToProps)

class FormUpload extends Component {

  state = {
    isUploading: false,
    errMessage: null,
    firstClick: false,
  }

  componentDidMount() {
    this._isMounted = true
  }

  componentWillUnmount() {
    this._isMounted = false
  }

  handleUpload = () => {
    const { files } = this.fileInput
    this.setState({ isUploading: true })
    if (files.length) {
      return CmsApis.getLinkMedia(files[0])
        .then((result) => {
          this.props.onChange(result);
          if (this._isMounted) {
            this.setState({ isUploading: false })
          }
        })
    }
  }

  render() {
    const { isUploading, errMessage } = this.state
    return (
      <Form>
        <Form.Group>
          <Form.Field onClick={() => this.setState({ firstClick: true })}>
            <input
              style={{
                padding: 3,
                fontSize: 12,
                cursor: 'pointer',
              }}
              type="file"
              ref={(input) => this.fileInput = input}
            />
          </Form.Field>
          { this.state.firstClick &&
          <Form.Button
            size="mini"
            loading={isUploading}
            onClick={this.handleUpload}
          >
            Upload
          </Form.Button>
          }
        </Form.Group>
        {errMessage && <span>{errMessage}</span>}
      </Form>
    )
  }
}

FormUpload.propTypes = {}
FormUpload.defaultProps = {}

export default enhancer(FormUpload)



// WEBPACK FOOTER //
// ./src/components/forms/FormUpload.js